import _sortBy from 'lodash/sortBy';

export const STATUS_ACTIVE = 'active';
export const DEFAULT_CLIENT_ID = 1;

export const sortClientResults = (clients) => {
  const defaultClient = clients.find(({ id }) => id === DEFAULT_CLIENT_ID);

  return [
    ...(defaultClient ? [defaultClient] : []),
    ..._sortBy(
      clients.filter(({ id }) => id !== DEFAULT_CLIENT_ID),
      [
        ({ name }) => name.toLowerCase()
      ]
    )
  ]
}
